import { FC, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import useClientData from '../../hooks/useClientData'
import useConfiguration from '../../hooks/useConfiguration'
import getQueryParams from '../../utils/getQueryParams'

const DataInitializer: FC = ({ children }) => {
  const navigate = useNavigate()
  const { pathname, search } = useLocation()

  const { configuration, getConfigurations } = useConfiguration()
  const { fetchClientData, error, clientData, getClientDataFromLocalStorage, setClientDataToLocalStorage } =
    useClientData()

  const slug = pathname.split('/')[1]
  const { userId, sessionToken } = getQueryParams({ url: window.location.search })
  const invalidSocialNumber = error && error.status === 404 && !clientData.document

  useEffect(() => {
    getClientDataFromLocalStorage()
  }, [])

  useEffect(() => {
    if (clientData.document && !error) {
      setClientDataToLocalStorage()
    }
  }, [clientData])

  useEffect(() => {
    if (!configuration) {
      getConfigurations(slug)
    } else if (!clientData.document) {
      fetchClientData({ userId, sessionToken, middleware: configuration.extensions.fetchClientDataMiddleware })
    }
  }, [configuration, slug, getConfigurations, userId, sessionToken])

  useEffect(() => {
    if (invalidSocialNumber && !pathname.includes('redirect')) {
      navigate(`/${configuration?.slug}/redirect${search}`, {
        state: {
          from: `${pathname}${search}`,
        },
      })
    }
  }, [invalidSocialNumber, navigate, pathname, search, configuration])

  return <>{children}</>
}

export default DataInitializer
